import { render } from "./Kalendar.vue?vue&type=template&id=5a72e204&scoped=true"
import script from "./Kalendar.vue?vue&type=script&lang=js"
export * from "./Kalendar.vue?vue&type=script&lang=js"

import "./Kalendar.vue?vue&type=style&index=0&id=5a72e204&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a72e204"

export default script